import React from "react";
import SiviElKopuk from "../Components/product/SiviElKopuk";
import PageHeader from "../Components/common/PageHeader";
import ProductSEO from "../Components/common/ProductSEO";
import { t } from "i18next";

function SiviElKopukPage() {
    return (
        <>
            <ProductSEO
                name="Sıvı El Köpük"
                description="Zengin köpük yapısı ile hızlı ve etkili el temizliği."
                slug="sivielkopuk"
                imagePath="assets/images/20-kg/12.webp"
            />
            <PageHeader title={t("SIVI EL KÖPÜK")} />
            <SiviElKopuk />
        </>
    );
}

export default SiviElKopukPage;